<template>
	<article class="itv-content-article">
		<div v-if="content.logo" class="itv-content-article__logo">
			<img :src="content.logo" alt="Логотип" width="155" height="56" />
		</div>
		<div class="itv-content-article__text" v-html="content.text"></div>
		<div v-if="content.button" class="itv-content-article__btn-wrap">
			<primary-button :content="content.button" />
		</div>
	</article>
</template>

<script>
import PrimaryButton from '../ui/PrimaryButton'

export default {
	name: 'ContentArticle',
	components: {
		PrimaryButton,
	},
	props: {
		content: {
			type: Object,
			default: () => {},
		},
	},
	methods: {
		articleHandler() {},
	},
}
</script>
